export default function formatVariantTitle(variant) {
  if (variant.options) return variant.options.join(" • ");
}
